import React, { useState, useEffect } from "react";

const RequestAccountDeletion = () => {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => {
    setShowModal(true);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ email, phone });
    setShowModal(false);
  };

  return (
    <div className="min-h-screen bg-lightgray flex items-center justify-center">
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md relative animate-fadeInUp">
            <button
              className="absolute top-3 right-3 text-gray-400 hover:text-primary text-2xl font-bold focus:outline-none"
              onClick={() => setShowModal(false)}
              aria-label="Close modal"
            >
              &times;
            </button>
            <h2 className="text-2xl font-bold text-primary mb-4 text-center">Request Account Deletion</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full px-4 py-3 rounded-lg bg-gray-100 border border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary text-gray-900 transition text-base"
                  placeholder="you@email.com"
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-1">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  className="w-full px-4 py-3 rounded-lg bg-gray-100 border border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary text-gray-900 transition text-base"
                  placeholder="Your phone number"
                />
              </div>
              <button
                type="submit"
                className="w-full px-6 py-3 rounded-lg bg-primary text-white font-bold text-lg shadow-md hover:bg-secondary transition duration-300 focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2"
              >
                Submit Request
              </button>
            </form>
          </div>
        </div>
      )}
      {/* Optionally, show a message after closing the modal */}
      {!showModal && (
        <div className="text-center">
          <h2 className="text-2xl font-bold text-primary mb-2">Request Submitted</h2>
          <p className="text-gray-700">Thank you! Your request has been received.</p>
        </div>
      )}
    </div>
  );
};

export default RequestAccountDeletion; 